import React from 'react';
import { useTranslation } from 'next-i18next';
import PriceContainer from '_components/Product/PriceContainer';
import { PriceGroup } from '@adapters/bigcommerce/types/product';

export interface ComparisonPriceContainerViewProps {
  price: PriceGroup;
  priceString: string | null;
  originalPriceString: string | null;
  className?: string;
  showOriginalPrice?: boolean;
}

/**
 * New comparison price UI behind the feature flag.
 * Formatted strings come from the parent (single useFormattedPrice call).
 */
const ComparisonPriceContainerView = ({
  price,
  priceString,
  originalPriceString,
  className,
  showOriginalPrice = true,
}: ComparisonPriceContainerViewProps) => {
  const { t } = useTranslation('comparison');
  const currentPriceValue = price.price?.value ?? price.lowPrice?.value;
  const originalPriceValue =
    price.basePrice?.value ?? price.baseLowPrice?.value;
  const discountPercentage =
    currentPriceValue &&
    originalPriceValue &&
    originalPriceValue > currentPriceValue
      ? Math.round(
          ((originalPriceValue - currentPriceValue) / originalPriceValue) * 100
        )
      : null;

  return (
    <PriceContainer
      className={className}
      price={priceString}
      originalPrice={showOriginalPrice ? originalPriceString : null}
      discountLabel={
        discountPercentage
          ? t('product.price.discount.percentage', {
              percent: discountPercentage,
            })
          : null
      }
    />
  );
};

export default ComparisonPriceContainerView;
